import { useTranslation } from 'react-i18next'

import { SUPPORTED_LOCALES } from '@/i18n/config'

/**
 * The application shell's language control (TASK-FB5DA982, batch contract
 * C-6). Calls `i18n.changeLanguage(lng)` and NOTHING else — persistence to
 * `px_locale` and reflecting the choice onto `<html lang>` are owned by the
 * existing `languageChanged` listener in `@/i18n/config` (the single source
 * of truth for those side effects; this component never duplicates them, and
 * a storage failure there is swallowed, so a switch never throws or renders
 * an error here either).
 */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation('nav')
  const resolved = i18n.resolvedLanguage ?? ''
  const active = (SUPPORTED_LOCALES as readonly string[]).includes(resolved) ? resolved : 'en'

  return (
    <select
      aria-label={t('language.label')}
      value={active}
      onChange={(e) => {
        void i18n.changeLanguage(e.target.value)
      }}
      data-testid="language-switcher"
      className="h-7 rounded-md border border-input bg-card px-1.5 text-xs text-muted-foreground hover:bg-muted"
    >
      {SUPPORTED_LOCALES.map((lng) => (
        <option key={lng} value={lng}>
          {t(`language.${lng}`)}
        </option>
      ))}
    </select>
  )
}
